<div class="w-full p-6">
  @if(isPartner && profileData){<div class="whiteCard p-5 my-2 item-multiple">
    <div class="flex items-center justify-between flex-wrap gap-x-1 gap-y-3">
      <div>
        <div class="titleWithBorder flex items-center gap-1.5 !mb-1 justify-between">
          {{profileData?.useShippingMatrix == 'own' ? 'Own Shipping Service' : 'Grimmor Shipping Service'}}
        </div>
      </div>
    </div>
  </div>}
  <div class="whiteCard p-5 my-2 item-multiple"
    [ngClass]="isPartner && profileData?.useShippingMatrix == 'grimmor' ? 'pointer-events-none' : ''">
    <div class="flex items-center justify-between flex-wrap gap-x-1 gap-y-3">
      <div>
        <div class="titleWithBorder flex items-center gap-1.5 !mb-1 justify-between">
          {{ LABELS.ZONES }}
        </div>
      </div>
    </div>
    <div class="modal-inner p-5">
      <form [formGroup]="zoneForm">
        <table class="matrix-table" formArrayName="zones">
          <thead>
            <tr>
              <th>Name</th>
              <th>Code</th>
              <th>Currency</th>
              <th>Base Shipping Cost</th>
              <th>Minimum Shipping Days</th>
              <th>Maximum Shipping Days</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let zone of zonesFormArray.controls; let i = index" [formGroupName]="i">
              <td class="data-border">
                <mat-form-field appearance="outline" class="input-wrapper w-full">
                  <input matInput formControlName="name" readonly disabled />
                </mat-form-field>
              </td>
              <td class="data-border">
                <mat-form-field appearance="outline" class="input-wrapper w-full">
                  <input matInput formControlName="code" readonly disabled />
                </mat-form-field>
              </td>
              <td>
                <mat-form-field appearance="outline" class="input-wrapper w-full">
                  <mat-select #currencyVal formControlName="currency" class="capitalize" required>
                    @for (c of currencyList; track currency) {
                    <mat-option [value]="c?.currency" class="capitalize">
                      {{ c?.currency + "(" + c?.symbol + ")" }}
                    </mat-option>
                    }
                  </mat-select>
                  @if (zone.get("currencySymbol")?.errors?.["required"]) {
                  <mat-error>
                    {{ LABELS.CURRENCY_REQUIRED }}
                  </mat-error>
                  }
                </mat-form-field>
              </td>
              <td>
                <mat-form-field appearance="outline" class="input-wrapper w-full">
                  <input matInput formControlName="shippingCharge" (keydown)="_helper.allowOnlyNumbersAndDot($event)" />
                  @if (zone.get("shippingCharge")?.errors?.["required"]) {
                  <mat-error>
                    {{ LABELS.SHIPPING_CHARGE_IS_REQUIRED }}
                  </mat-error>
                  }
                </mat-form-field>
              </td>
              <td>
                <mat-form-field appearance="outline" class="input-wrapper w-full">
                  <input type="number" matInput formControlName="minShippingDays"
                    (keydown)="_helper.allowOnlyNumbersAndDot($event)" />
                  @if (zone.get("minShippingDays")?.errors?.["required"]) {
                  <mat-error>
                    {{ LABELS.MINIMUM_SHIPPING_DAYS_IS_REQUIRED }}
                  </mat-error>
                  }
                </mat-form-field>
              </td>
              <td>
                <mat-form-field appearance="outline" class="input-wrapper w-full">
                  <input matInput type="number" formControlName="maxShippingDays"
                    [min]="zone?.get('minShippingDays')?.value" (keydown)="_helper.allowOnlyNumbersAndDot($event)" />
                  @if (zone.get("maxShippingDays")?.errors?.["required"]) {
                  <mat-error>
                    {{ LABELS.MAXIMUM_SHIPPING_DAYS_IS_REQUIRED }}
                  </mat-error>
                  }
                </mat-form-field>
              </td>
            </tr>
          </tbody>
        </table>

        @if((isPartner && profileData?.useShippingMatrix == 'own') || !isPartner){<div class="flex justify-end mt-6">
          <button mat-flat-button class="btn-theme-color !min-w-[90px]" type="button" [disabled]="isLoad"
            (click)="saveZones()">
            {{ LABELS.SAVE }}
          </button>
        </div>}
      </form>
    </div>
  </div>

  <div class="whiteCard p-5 my-2 item-multiple"
    [ngClass]="isPartner && profileData?.useShippingMatrix == 'grimmor' ? 'pointer-events-none' : ''">
    <div class="flex items-center justify-between flex-wrap gap-x-1 gap-y-3">
      <div>
        <div class="titleWithBorder flex items-center gap-1.5 !mb-1 justify-between">
          {{ LABELS.MATRIX_HEADER }}
        </div>
      </div>
    </div>
    <div class="modal-inner p-5">
      <div class="matrix-wrapper">
        <table class="matrix-table">
          <thead>
            <tr>
              <th>Origin / Destination</th>
              <th *ngFor="let dest of countries; let i = index">{{ dest }}</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let origin of countries">
              <td class="origin">{{ origin }}</td>

              <td *ngFor="let dest of countries" [formGroup]="originDestinationForm.get(origin)">
                <mat-form-field appearance="outline" class="matrix-field">
                  <mat-select [formControlName]="dest">
                    <ng-container *ngFor="let zone of ZONES">
                      <mat-option *ngIf="zone.code != '-'" [value]="zone.code">
                        {{ zone.code }}
                      </mat-option>
                    </ng-container>
                  </mat-select>
                </mat-form-field>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      @if((isPartner && profileData?.useShippingMatrix == 'own') || !isPartner){<div class="flex justify-end mt-6">
        <button mat-flat-button class="btn-theme-color !min-w-[90px]" type="button" [disabled]="isLoad"
          (click)="saveMatrix()">
          {{ LABELS.SAVE }}
        </button>
      </div>}
    </div>
  </div>

  <div class="whiteCard p-5 my-2 item-multiple"
    [ngClass]="isPartner && profileData?.useShippingMatrix == 'grimmor' ? 'pointer-events-none' : ''">
    <div class="flex items-center justify-between flex-wrap gap-x-1 gap-y-3">
      <div>
        <div class="titleWithBorder flex items-center gap-1.5 !mb-1 justify-between">
          {{ LABELS.ITEM_MULTIPLIER }}
        </div>
      </div>
    </div>
    <div class="modal-inner p-5">
      <form [formGroup]="IMForm">
        <div class="matrix-wrapper">
          <table class="matrix-table" formArrayName="items">
            <thead>
              <tr>
                <th>No. of items</th>
                <th>Out wear</th>
                <th>Top wear</th>
                <th>One piece</th>
                <th>Bottom wear</th>
                <th>Shoes</th>
                <th>Accessories</th>
                @if((isPartner && profileData?.useShippingMatrix == 'own') || !isPartner){<th>Action</th>}
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let imf of IMFArray.controls; let i = index" [formGroupName]="i">
                <!-- <td class="origin">{{ origin }}</td> -->

                <td class="data-border">
                  <mat-form-field appearance="outline" class="input-wrapper w-full">
                    <!-- <mat-label>{{ LABELS.NOOFITEMS }}</mat-label> -->
                    <input matInput formControlName="noOfItems" readonly disabled
                      (keydown)="_helper.allowOnlyNumbersAndDot($event)" />
                    @if (imf.get("noOfItems")?.hasError("required")) {
                    <mat-error>
                      {{ LABELS.NOOFITEMS_REQUIRED }}
                    </mat-error>
                    }
                  </mat-form-field>
                </td>

                <td>
                  <mat-form-field appearance="outline" class="input-wrapper w-full">
                    <!-- <mat-label>{{ LABELS.OUTWEAR }}</mat-label> -->
                    <input matInput formControlName="outwear" (keydown)="_helper.allowOnlyNumbersAndDot($event)" />
                    @if (imf.get("outwear")?.hasError("required")) {
                    <mat-error>
                      {{ LABELS.OUTWEAR_VALUE_IS_REQUIRED }}
                    </mat-error>
                    }
                  </mat-form-field>
                </td>

                <td>
                  <mat-form-field appearance="outline" class="input-wrapper w-full">
                    <!-- <mat-label>{{ LABELS.TOP }}</mat-label> -->
                    <input matInput formControlName="top" (keydown)="_helper.allowOnlyNumbersAndDot($event)" />
                    @if (imf.get("top")?.hasError("required")) {
                    <mat-error>
                      {{ LABELS.TOP_VALUE_IS_REQUIRED }}
                    </mat-error>
                    }
                  </mat-form-field>
                </td>

                <td>
                  <!-- <div class="w-full"> -->
                  <mat-form-field appearance="outline" class="input-wrapper w-full">
                    <!-- <mat-label>{{ LABELS.ONEPIECE }}</mat-label> -->
                    <input matInput formControlName="onePiece" (keydown)="_helper.allowOnlyNumbersAndDot($event)" />
                    @if (imf.get("onePiece")?.hasError("required")) {
                    <mat-error>
                      {{ LABELS.ONEPIECE_VALUE_IS_REQUIRED }}
                    </mat-error>
                    }
                  </mat-form-field>
                  <!-- </div> -->
                </td>

                <td>
                  <!-- <div class="w-full"> -->
                  <mat-form-field appearance="outline" class="input-wrapper w-full">
                    <!-- <mat-label>{{ LABELS.BOTTOM }}</mat-label> -->
                    <input matInput formControlName="bottom" (keydown)="_helper.allowOnlyNumbersAndDot($event)" />
                    @if (imf.get("bottom")?.hasError("required")) {
                    <mat-error>
                      {{ LABELS.BOTTOM_VALUE_IS_REQUIRED }}
                    </mat-error>
                    }
                  </mat-form-field>
                  <!-- </div> -->
                </td>
                <td>
                  <!-- <div class="w-full"> -->
                  <mat-form-field appearance="outline" class="input-wrapper w-full">
                    <!-- <mat-label>{{ LABELS.SHOES }}</mat-label> -->
                    <input matInput formControlName="shoes" (keydown)="_helper.allowOnlyNumbersAndDot($event)" />
                    @if (imf.get("shoes")?.hasError("required")) {
                    <mat-error>
                      {{ LABELS.SHOES_VALUE_IS_REQUIRED }}
                    </mat-error>
                    }
                  </mat-form-field>
                  <!-- </div> -->
                </td>
                <td>
                  <!-- <div class="w-full"> -->
                  <mat-form-field appearance="outline" class="input-wrapper w-full">
                    <!-- <mat-label>{{ LABELS.ACCESSORIES }}</mat-label> -->
                    <input matInput formControlName="accessories" (keydown)="_helper.allowOnlyNumbersAndDot($event)" />
                    @if (imf.get("accessories")?.hasError("required")) {
                    <mat-error>
                      {{ LABELS.ACCESSORIES_VALUE_IS_REQUIRED }}
                    </mat-error>
                    }
                  </mat-form-field>
                  <!-- </div> -->
                </td>
                @if((isPartner && profileData?.useShippingMatrix == 'own') || !isPartner){<td
                  class="flex gap-4 justify-end items-center !h-full min-h-[70px] min-w-[160px]">
                  <button *ngIf="IMFArray.length > 1" [color]="'warn'" class="-ml-4 btn-red-color !w-[60px]" mat-button
                    type="button" [disabled]="isLoad" (click)="removeIMFGroup(i)">
                    {{ LABELS.DELETE }}
                  </button>
                  <button mat-flat-button *ngIf="IMFArray.length == i + 1" class="btn-theme-color !w-[60px]"
                    type="button" [disabled]="isLoad" (click)="addIMFGroup()">
                    {{ LABELS.ADD }}
                  </button>
                </td>}
              </tr>
            </tbody>
          </table>
        </div>
        <!-- <div class="" formArrayName="items">
          <div
                  *ngFor="let imf of IMFArray.controls; let i = index"
                  [formGroupName]="i"
                  class="grid grid-cols-1 md:grid-cols-4   gap-4 items-center  p-2 mb-3  border-b-2 border-[#00000]"
          >
            <div>
              <mat-form-field appearance="outline" class="input-wrapper w-full">
                <mat-label>{{LABELS.NOOFITEMS}}</mat-label>
                <input matInput formControlName="noOfItems"  (keydown)="_helper.allowOnlyNumbersAndDot($event)">
                @if ( imf.get('noOfItems')?.hasError('required')){
                  <mat-error>
                    {{LABELS.NOOFITEMS_REQUIRED}}
                  </mat-error>
                }
              </mat-form-field>
            </div>

            <div>
              <mat-form-field appearance="outline" class="input-wrapper w-full">
                <mat-label>{{LABELS.OUTWEAR}}</mat-label>
                <input matInput formControlName="outwear"  (keydown)="_helper.allowOnlyNumbersAndDot($event)">
                @if ( imf.get('outwear')?.hasError('required')){
                  <mat-error>
                    {{LABELS.OUTWEAR_VALUE_IS_REQUIRED}}
                  </mat-error>
                }
              </mat-form-field>
            </div>

            <div>
              <mat-form-field appearance="outline" class="input-wrapper w-full">
                <mat-label>{{LABELS.TOP}}</mat-label>
                <input matInput formControlName="top"  (keydown)="_helper.allowOnlyNumbersAndDot($event)">
                @if (imf.get('top')?.hasError('required')){
                  <mat-error>
                    {{LABELS.TOP_VALUE_IS_REQUIRED}}
                  </mat-error>
                }
              </mat-form-field>
            </div>

            <div class="flex flex-col gap-2">
              <div class="w-full">
                <mat-form-field appearance="outline" class="input-wrapper w-full">
                  <mat-label>{{LABELS.ONEPIECE}}</mat-label>
                  <input matInput formControlName="onePiece"  (keydown)="_helper.allowOnlyNumbersAndDot($event)">
                  @if (imf.get('onePiece')?.hasError('required')){
                    <mat-error>
                      {{LABELS.ONEPIECE_VALUE_IS_REQUIRED}}
                    </mat-error>
                  }
                </mat-form-field>
              </div>
            </div>


            <div class="flex flex-col gap-2">
              <div class="w-full">
                <mat-form-field appearance="outline" class="input-wrapper w-full">
                  <mat-label>{{LABELS.BOTTOM}}</mat-label>
                  <input matInput formControlName="bottom"  (keydown)="_helper.allowOnlyNumbersAndDot($event)">
                  @if (imf.get('bottom')?.hasError('required')){
                    <mat-error>
                      {{LABELS.BOTTOM_VALUE_IS_REQUIRED}}
                    </mat-error>
                  }
                </mat-form-field>
              </div>
            </div>
            <div class="flex flex-col gap-2">
              <div class="w-full">
                <mat-form-field appearance="outline" class="input-wrapper w-full">
                  <mat-label>{{LABELS.SHOES}}</mat-label>
                  <input matInput formControlName="shoes"  (keydown)="_helper.allowOnlyNumbersAndDot($event)">
                  @if (imf.get('shoes')?.hasError('required')){
                    <mat-error>
                      {{LABELS.SHOES_VALUE_IS_REQUIRED}}
                    </mat-error>
                  }
                </mat-form-field>
              </div>
            </div>
            <div class="flex flex-col gap-2">
              <div class="w-full">
                <mat-form-field appearance="outline" class="input-wrapper w-full">
                  <mat-label>{{LABELS.ACCESSORIES}}</mat-label>
                  <input matInput formControlName="accessories"  (keydown)="_helper.allowOnlyNumbersAndDot($event)">
                  @if (imf.get('accessories')?.hasError('required')){
                    <mat-error>
                      {{LABELS.ACCESSORIES_VALUE_IS_REQUIRED}}
                    </mat-error>
                  }
                </mat-form-field>
              </div>
            </div>
            <div class="flex gap-4 justify-end  items-start !h-full">
              <button  *ngIf="IMFArray.length > 1" [color]="'warn'" class="-ml-4 btn-red-color !w-[60px]" mat-button type="button" [disabled]="isLoad"   (click)="removeIMFGroup(i)">{{LABELS.DELETE}}</button>
              <button mat-flat-button  *ngIf="IMFArray.length == i+1"  class="btn-theme-color !w-[60px]" type="button"  [disabled]="isLoad"   (click)="addIMFGroup()"> {{LABELS.ADD }}</button>
            </div>

          </div>
        </div> -->

        @if((isPartner && profileData?.useShippingMatrix == 'own') || !isPartner){<div class="flex justify-end mt-6">
          <button mat-flat-button class="btn-theme-color !min-w-[90px]" type="button" [disabled]="isLoad"
            (click)="saveItemsData()">
            {{ LABELS.SAVE }}
          </button>
        </div>}
      </form>
    </div>
  </div>
</div>